export default __webpack_public_path__ + "0623af9.png";